import { useMutation } from 'react-query';

import { deleteAbsence } from 'RestAPIs/absence';

import { showErrorSnackbar, showSuccessSnackbar } from '../Snackbar';

type DeleteAbsenceMutationOptions = {
  absenceId: number;
  startDate: string | null;
  endDate: string | null;
};
export const useDeleteAbsenceMutation = () => {
  return useMutation(
    (options: DeleteAbsenceMutationOptions) => deleteAbsence(options),
    {
      onSuccess: () => {
        showSuccessSnackbar();
      },
      onError: () => {
        showErrorSnackbar();
      }
    }
  );
};
